import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-unauthorizeview',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './unauthorizeview.component.html',
})
export class UnauthorizeViewComponent {

}
